module.exports = __webpack_public_path__ + "img/crepuscle-rig.b3615593.jpg";